<template>
  <div>
    <div class="pa-3">
      <v-subheader>Plantilla</v-subheader>
      <v-divider></v-divider>
      <v-item-group class="d-flex align-center flex-wrap mt-2" mandatory style="gap: 20px"
        v-model="opcionesAutoestudio.plantilla">
        <v-item :value="val" v-for="[val, plantilla] in Object.entries(plantillas)" :key="val"
          v-slot="{ active, toggle }">
          <v-card outlined class="pa-2 pa-2 px-4 rounded-md d-flex" @click="toggle">
            <h4>{{ plantilla.name }}</h4>
          </v-card>
        </v-item>
      </v-item-group>

      <v-item-group v-if="opcionesAutoestudio.plantilla == 'COLABORADORES_EXT'">
        <v-subheader>Colaborador externo</v-subheader>
        <v-divider></v-divider>
        <v-select
          v-model="opcionesAutoestudio.idColaboradorExterno"
          :items="colaboradoresExternos"
          item-text="nombre"
          item-value="id"
          label="Selecciona una empresa"
        />
      </v-item-group>

      <v-item-group v-if="opcionesAutoestudio.plantilla == 'NUEVA_AISLADA'">
        <v-subheader>Presupuesto</v-subheader>
        <v-divider></v-divider>
        <v-select v-model="opcionesAutoestudio.aisladas" :items="OpcionesAisladas" item-text="label" item-value="key"
          label="Selecciona una opción" />
      </v-item-group>

      <div v-if="opcionesAutoestudio.plantilla == 'NUEVA_ESTANDAR_BATERIAS'">

        <v-subheader>Baterias</v-subheader>
        <v-divider></v-divider>
        <v-item-group class="d-flex align-center flex-wrap mt-2" mandatory style="gap: 20px">
          <v-item>Cantidad </v-item>
          <v-text-field v-model="opcionesAutoestudio.baterias" label="Numero de modulos 5kwh" type="number"
            model-value="1" />
          <!-- <v-select v-model="opcionesAutoestudio.baterias" :items="OpcionesVoltajeBaterias" item-text="label"
            item-value="key" label="Selecciona una cantidad" /> -->
        </v-item-group>
      </div>

      <v-subheader>Lecturas</v-subheader>
      <v-divider></v-divider>
      <v-item-group class="d-flex align-center flex-wrap mt-2" mandatory style="gap: 20px">
        <v-item v-slot="{ active, toggle }">
          <v-card outlined class="pa-2 pa-2 px-4 rounded-md d-flex" @click="
            toggle();
          lecturas_manuales = null;
          ">
            <h4>Lecturas SIPS</h4>
          </v-card>
        </v-item>
        <v-item v-slot="{ active, toggle }">
          <v-card outlined class="pa-2 rounded-md d-flex">
            <v-file-input dense hide-details filled @input="toggle" @change="toggle" v-model="lecturas_manuales"
              hint=".csv" accept=".csv" placeholder="Selecciona tu archivo con las lecturas"></v-file-input>
          </v-card>
        </v-item>
        <v-btn @click.stop="descargarPlantillaLecturas" small color="primary">
          <v-icon left>mdi-download</v-icon>
          Plantilla
        </v-btn>
      </v-item-group>
      <div class="my-2"></div>
      <v-subheader>Tipo de consumidor</v-subheader>
      <v-divider></v-divider>
      <v-item-group v-model="opcionesAutoestudio.curva" mandatory
        class="d-flex align-center justify-space-around flex-wrap mt-2" style="gap: 20px">
        <v-item v-for="[val, curva] in Object.entries(curvas)" :key="val" :value="val" v-slot="{ toggle }">
          <v-card outlined class="item-selection align-center pa-4 ma-1"
            style="height: 150px; width: 150px; aspect-ratio: 1" @click.stop="toggle">
            <h4>{{ curva.name }}</h4>
            <v-icon large>{{ curva.icon }}</v-icon>
            <v-sparkline :value="curva.curva" color="secondary" line-width="6"></v-sparkline>
          </v-card>
        </v-item>
        <v-text-field style="max-width: 150px;" label="Excedentes" suffix="%"
          v-model="opcionesAutoestudio.excedentes_buscados" dense hide-details filled type="number"></v-text-field>
      </v-item-group>

      <div class="my-2"></div>
      <v-subheader>Tipo de estructura</v-subheader>
      <v-divider></v-divider>
      <v-item-group v-model="opcionesAutoestudio.estructura" mandatory class="d-flex align-center flex-wrap mt-2"
        style="gap: 20px">
        <v-item v-for="val in Object.keys(estructuras)" :key="val" :value="val" v-slot="{ toggle }">
          <v-card outlined class="item-selection align-center pa-2 px-4 ma-1" @click.stop="toggle">
            <h4>{{ val }}</h4>
          </v-card>
        </v-item>
      </v-item-group>

      <div class="my-2"></div>
      <v-subheader>Panel</v-subheader>
      <v-divider></v-divider>
      <v-item-group mandatory class="d-flex align-center flex-wrap mt-2" style="gap: 20px">
        <v-item v-slot="{ active, toggle }">
          <v-card outlined class="pa-2 pa-2 px-4 rounded-md d-flex" @click="
            toggle();
          opcionesAutoestudio.idPanel = null;
          ">
            <h4>Según consumidor</h4>
          </v-card>
        </v-item>
        <v-item v-slot="{ active, toggle }">
          <v-card outlined class="pa-2 rounded-md d-flex">
            <v-select :items="paneles" item-value="idPanel" dense hide-details filled @change="toggle"
              v-model="opcionesAutoestudio.idPanel">
              <template v-slot:selection="{ item }">
                <v-list-item-title>
                  {{ item.nombre }}
                  -
                  {{ item.potencia }} kWp
                </v-list-item-title>
              </template>
              <template v-slot:item="{ item, on, attrs }">
                <v-list-item-content>
                  <v-list-item-title>{{ item.nombre }}</v-list-item-title>
                  <v-list-item-subtitle>{{ item.potencia }} kWp</v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-select>
          </v-card>
        </v-item>
      </v-item-group>

      <div class="my-2"></div>
      <!-- <v-text-field
                  filled
                  dense
                  hide-details="auto"
                  label="Potencia"
                  type="number"
                  v-model="opcionesAutoestudio.potencia_solicitada"
                ></v-text-field> -->
      <v-subheader>Potencia de la instalación</v-subheader>
      <v-divider></v-divider>
      <v-item-group class="d-flex align-center flex-wrap mt-2" mandatory style="gap: 20px">
        <v-item v-slot="{ active, toggle }">
          <v-card outlined class="pa-2 pa-2 px-4 rounded-md d-flex" @click="
            toggle();
          opcionesAutoestudio.potencia_solicitada = null;
          ">
            <h4>Optimización automática</h4>
          </v-card>
        </v-item>
        <v-item v-slot="{ active, toggle }">
          <v-card outlined class="pa-2 pa-2 px-4 rounded-md d-flex" :disabled="!estudio.cubiertas" @click="
            toggle();
          opcionesAutoestudio.potencia_solicitada = 'Coste 0';
          ">
            <h4>Estudio coste 0</h4>
          </v-card>
        </v-item>
        <v-item v-slot="{ active, toggle }">
          <v-card outlined class="pa-2 rounded-md d-flex">
            <v-text-field dense hide-details filled suffix="kWp" @input="toggle" type="number"
              v-model="opcionesAutoestudio.potencia_solicitada"></v-text-field>
          </v-card>
        </v-item>
      </v-item-group>

      <v-divider class="my-2"></v-divider>

      <template v-if="$root.acceso('EDITAR_ESTUDIOS')">
        <v-subheader>Precio de la instalación</v-subheader>
        <v-divider></v-divider>
        <v-item-group class="d-flex align-center flex-wrap mt-2" mandatory style="gap: 20px">
          <v-item v-slot="{ active, toggle }">
            <v-card outlined class="pa-2 pa-2 px-4 rounded-md d-flex" @click="
              toggle();
            opcionesAutoestudio.precio_wp = null;
            ">
              <h4>Calcular según potencia</h4>
            </v-card>
          </v-item>
          <v-item v-slot="{ active, toggle }">
            <v-card outlined class="pa-2 rounded-md d-flex">
              <v-text-field dense hide-details filled suffix="€ Wp" @input="toggle" type="number"
                v-model="opcionesAutoestudio.precio_wp"></v-text-field>
            </v-card>
          </v-item>
        </v-item-group>
      </template>

      <v-subheader>Superficie disponible</v-subheader>
      <v-divider></v-divider>
      <v-item-group class="d-flex align-center flex-wrap mt-2" mandatory style="gap: 20px">
        <v-item v-slot="{ active, toggle }">
          <v-card outlined class="pa-2 pa-2 px-4 rounded-md d-flex" @click="
            toggle();
          opcionesAutoestudio.superficie_disponible = null;
          ">
            <h4>Indefinida</h4>
          </v-card>
        </v-item>
        <v-item v-slot="{ active, toggle }">
          <v-card outlined class="pa-2 pa-2 px-4 rounded-md d-flex" :disabled="!estudio.cubiertas" @click="
            toggle();
          opcionesAutoestudio.superficie_disponible = 'cubiertas';
          ">
            <h4>Según cubiertas marcadas</h4>
          </v-card>
        </v-item>
        <v-item v-slot="{ active, toggle }">
          <v-card outlined class="pa-2 rounded-md d-flex">
            <v-text-field dense hide-details filled suffix="m²" @input="toggle" type="number"
              v-model="opcionesAutoestudio.superficie_disponible"></v-text-field>
          </v-card>
        </v-item>
      </v-item-group>

      <template v-if="$root.acceso('EDITAR_ESTUDIOS')">
        <v-divider></v-divider>
        <v-subheader>Término opcional *<small>Se aplicará al precio de instalación</small></v-subheader>
        <v-row class="align-center">
          <v-col>
            <v-text-field dense hide-details filled suffix="€" type="number"
              v-model="opcionesAutoestudio.precio_extra"></v-text-field>
          </v-col>
          <v-col>
            <v-text-field dense hide-details filled suffix="%" type="number"
              v-model="opcionesAutoestudio.precio_extra_pct"></v-text-field>
          </v-col>
        </v-row>
      </template>

      <v-divider class="my-2"></v-divider>

      <v-subheader>Simulación comunidad</v-subheader>
      <v-text-field placeholder="Nº vecinos" filled dense hide-details v-model="opcionesAutoestudio.simulacion_vecinos"
        type="number"></v-text-field>

      <v-divider class="my-2"></v-divider>

      <v-row>
        <v-col cols="12" md="4">
          <v-text-field filled dense hide-details="auto" label="Precio medio kWh" type="number"
            v-model="opcionesAutoestudio.precio_medio"></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field filled dense hide-details="auto" label="Inclinación" type="number"
            v-model="opcionesAutoestudio.inclinacion" suffix="º" :disabled="!!estudio.inclinacion"></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field filled dense hide-details="auto" label="Azimut" type="number"
            v-model="opcionesAutoestudio.azimut" suffix="º" :disabled="!!estudio.azimut"></v-text-field>
        </v-col>
      </v-row>

      <v-divider class="my-2"></v-divider>

      <v-row class="align-center">
        <v-col cols="12" md="3">
          <v-checkbox filled dense hide-details="auto" v-model="opcionesAutoestudio.calcular_financiacion"
            label="Incluir financiacion"></v-checkbox>
        </v-col>
        <v-col cols="12" md="4" v-if="$root.acceso('EDITAR_ESTUDIOS')">
          <v-text-field filled dense hide-details="auto" type="number" v-model="opcionesAutoestudio.interes"
            :disabled="!opcionesAutoestudio.calcular_financiacion" label="Interes anual"></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field filled dense hide-details="auto" type="number" label="Años financiacion"
            v-model="opcionesAutoestudio.años_financiacion"
            :disabled="!opcionesAutoestudio.calcular_financiacion"></v-text-field>
        </v-col>
      </v-row>

      <v-divider class="my-2"></v-divider>

      <v-row>
        <v-col cols="12">
          <v-checkbox filled dense hide-details="auto" v-model="opcionesAutoestudio.aplicar_iva"
            label="Aplicar IVA"></v-checkbox>
        </v-col>
      </v-row>
      <div class="my-2"></div>
      <v-subheader>Promoción</v-subheader>
      <v-divider></v-divider>
      <v-item-group v-model="opcionesAutoestudio.promocion" mandatory class="d-flex align-center flex-wrap mt-2"
        style="gap: 20px">
        <v-item :value="null" v-slot="{ toggle }">
          <v-card outlined class="item-selection align-center pa-2 px-4 ma-1" @click.stop="toggle">
            <h4>Automático</h4>
          </v-card>
        </v-item>
        <v-item value="NINGUNA" v-slot="{ toggle }">
          <v-card outlined class="item-selection align-center pa-2 px-4 ma-1" @click.stop="toggle">
            <h4>Ninguna</h4>
          </v-card>
        </v-item>
        <v-item v-for="val in promociones" :key="val.idPromocion" :value="val.idPromocion" v-slot="{ toggle }">
          <v-card outlined class="item-selection align-center pa-2 px-4 ma-1" @click.stop="toggle">
            <h4>{{ val.nombre }}</h4>
          </v-card>
        </v-item>
      </v-item-group>

      <div class="my-2"></div>
      <v-subheader>Subvencion</v-subheader>
      <v-divider></v-divider>
      <v-item-group v-model="opcionesAutoestudio.subvencion" mandatory class="d-flex align-center flex-wrap mt-2"
        style="gap: 20px">
        <v-item :value="null" v-slot="{ toggle }">
          <v-card outlined class="item-selection align-center pa-2 px-4 ma-1" @click.stop="toggle">
            <h4>No</h4>
          </v-card>
        </v-item>
        <v-item v-for="[val, name] in Object.entries(subvenciones)" :key="val" :value="val" v-slot="{ toggle }">
          <v-card outlined class="item-selection align-center pa-2 px-4 ma-1" @click.stop="toggle">
            <h4>{{ name }}</h4>
          </v-card>
        </v-item>
      </v-item-group>

      <div class="my-2"></div>
      <v-subheader>PPA</v-subheader>
      <v-divider></v-divider>
      <v-item-group v-model="opcionesAutoestudio.ppa" mandatory class="d-flex align-center flex-wrap mt-2"
        style="gap: 20px">
        <v-item :value="null" v-slot="{ toggle }">
          <v-card outlined class="item-selection align-center pa-2 px-4 ma-1" @click.stop="toggle">
            <h4>No</h4>
          </v-card>
        </v-item>
        <v-item v-for="[val, ppa] in Object.entries(ppas)" :key="val" :value="val" v-slot="{ toggle }">
          <v-card outlined class="item-selection align-center pa-2 px-4 ma-1" @click.stop="toggle">
            <h4>{{ ppa.name }}</h4>
          </v-card>
        </v-item>
      </v-item-group>

      <v-divider class="my-2"></v-divider>

      <v-row class="align-center">
        <v-col cols="12" md="3">
          <v-checkbox filled dense hide-details="auto" v-model="opcionesAutoestudio.precio_oferta_alumbra"
            label="Oferta Alumbra"></v-checkbox>
        </v-col>
        <v-col cols="12" md="4" v-if="$root.acceso('EDITAR_ESTUDIOS')">
          <v-text-field filled dense hide-details="auto" type="number"
            v-model="opcionesAutoestudio.precio_oferta_compra_alumbra"
            :disabled="!opcionesAutoestudio.precio_oferta_alumbra" required label="Precio compra"
            placeholder="0.08"></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field filled dense hide-details="auto" type="number" label="Precio venta"
            v-model="opcionesAutoestudio.precio_oferta_venta_alumbra" required v-bind:value="{ number: 0.03 }"
            :disabled="!opcionesAutoestudio.precio_oferta_alumbra"></v-text-field>
        </v-col>
      </v-row>

      <div class="my-2"></div>
      <v-divider class="my-2"></v-divider>
      <v-checkbox filled dense hide-details="auto" v-model="opcionesAutoestudio.precio_ibi"
        label="Deducción IBI"></v-checkbox>
      <v-item-group mandatory class="d-flex align-center flex-wrap mt-2" style="gap: 20px">
        <v-item v-slot="{ active, toggle }">
          <v-card outlined class="pa-2 rounded-md d-flex" @click="toggle()">
            <v-text-field filled dense hide-details="auto" type="number" v-model="opcionesAutoestudio.porcentaje_ibi"
              label="% IBI" :disabled="!opcionesAutoestudio.precio_ibi"
              :rules="[() => !opcionesAutoestudio.precio_ibi || !!opcionesAutoestudio.porcentaje_ibi || 'Este campo es obligatorio.']"></v-text-field>
          </v-card>
        </v-item>
        <v-item v-slot="{ active, toggle }">
          <v-card outlined class="pa-2 rounded-md d-flex" @click="toggle()">
            <v-text-field filled dense hide-details="auto" type="number" v-model="opcionesAutoestudio.anos_ibi"
              label="Años IBI" :disabled="!opcionesAutoestudio.precio_ibi"
              :rules="[() => !opcionesAutoestudio.precio_ibi || !!opcionesAutoestudio.anos_ibi || 'Este campo es obligatorio.']"></v-text-field>
          </v-card>
        </v-item>
        <v-item v-slot="{ active, toggle }">
          <v-card outlined class="pa-2 rounded-md d-flex" @click="toggle()">
            <v-text-field filled dense hide-details="auto" type="number" v-model="opcionesAutoestudio.coste_ibi"
              label="Coste IBI" :disabled="!opcionesAutoestudio.precio_ibi"
              :rules="[() => !opcionesAutoestudio.precio_ibi || !!opcionesAutoestudio.coste_ibi || 'Este campo es obligatorio.']"></v-text-field>
          </v-card>
        </v-item>
      </v-item-group>

    </div>
    <v-dialog :value="error" max-width="500">
      <v-card>
        <v-alert class="ma-0" type="error" outlined text>
          {{ error }}
        </v-alert>
      </v-card>

    </v-dialog>
  </div>
</template>

<script setup>
import { downloadFile } from "@/utils/index.js";
import { useVModel } from "@vueuse/core";
import { ref, watch, computed } from "vue";
import axios from "@/utils/axiosWrapper";

const props = defineProps({
  idEstudio: Number,
  estudio: Object,
  value: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits([
  "update:creatingAutoestudio",
  "update:value",
  "reload",
]);

const opcionesAutoestudio = useVModel(props, "value", emit);

function getDefaultAngleValue(value) {
  return value === null || value === undefined || value === "" ? 0 : value;
}

opcionesAutoestudio.value = {
  curva: "SERVICIO_GENERAL",
  aisladas: null,
  baterias: null,
  precio_medio_kWh: null,
  show: false,
  potencia_solicitada: null,
  calcular_financiacion: true,
  precio_wp: null,
  precio_extra: 0,
  precio_extra_pct: 1,
  inclinacion: getDefaultAngleValue(props.estudio.inclinacion),
  azimut: getDefaultAngleValue(props.estudio.azimut),
  superficie_disponible: null,
  simulacion_vecinos: null,
  idColaboradorExterno: null,
  aplicar_iva: false,
  promocion: null,
  precio_oferta_alumbra: true,
  precio_oferta_venta_alumbra: 0,
  precio_oferta_compra_alumbra: 0,
  precio_ibi: false,
  porcentaje_ibi: null,
  anos_ibi: null,
  coste_ibi: null,
  ...opcionesAutoestudio.value,
};

const lecturas_manuales = ref(null);

const {
  data,
  error,
  pending: creatingAutoestudio,
  refresh: crearEstudio,
} = axios({
  method: "POST",
  url: `${process.env.VUE_APP_API_URL}/autoestudios/${props.idEstudio}`,
  responseType: "blob",
  headers: {
    "Content-Type": "multipart/form-data",
  },
  lazy: true,
  block: true,
  transformError: async (err) => {
    try {
      return JSON.parse(await err.response.data.text()).detail;
    } catch (_parseError) {
      return err?.response?.statusText || "No se ha podido generar el autoestudio";
    }
  },
});

watch(creatingAutoestudio, (v) => emit("update:creatingAutoestudio", v));

const OpcionesAisladas = computed(() => {
  return Object.entries(aisladas.value).map(([key, value]) => ({
    key: key,
    label: value.name,
    value: value,
  }));
});


const { data: plantillas } = axios(
  `${process.env.VUE_APP_API_URL}/autoestudios/plantillas`,
  { default: () => [] }
);
const { data: estructuras } = axios(
  `${process.env.VUE_APP_API_URL}/autoestudios/estructuras`,
  { default: () => [] }
);
const { data: curvas } = axios(
  `${process.env.VUE_APP_API_URL}/autoestudios/curvas`,
  { default: () => ({}) }
);
const { data: paneles } = axios(
  `${process.env.VUE_APP_API_URL}/autoestudios/paneles`,
  { default: () => [] }
);
const { data: promociones } = axios(
  `${process.env.VUE_APP_API_URL}/autoestudios/promociones`,
  { default: () => [] }
);
const { data: subvenciones } = axios(
  `${process.env.VUE_APP_API_URL}/autoestudios/subvenciones`,
  { default: () => [] }
);
const { data: aisladas } = axios(
  `${process.env.VUE_APP_API_URL}/autoestudios/aisladas`,
  { default: () => [] }
);

const { data: ppas } = axios(
  `${process.env.VUE_APP_API_URL}/autoestudios/ppas`,
  { default: () => [] }
);

const {
  data: colaboradoresExternos,
  refresh: cargarColaboradoresExternos,
} = axios(`${process.env.VUE_APP_API_URL}/colaboradores_externos`, {
  default: () => [],
  lazy: true,
});

watch(
  () => opcionesAutoestudio.value?.plantilla,
  (plantilla) => {
    if (plantilla !== "NUEVA_ESTANDAR_BATERIAS") {
      opcionesAutoestudio.value.baterias = null;
    }

    if (
      plantilla === "COLABORADORES_EXT" &&
      (!Array.isArray(colaboradoresExternos.value) ||
        colaboradoresExternos.value.length === 0)
    ) {
      cargarColaboradoresExternos();
    }
  },
  { immediate: true }
);

function descargarPlantillaLecturas() {
  const plantilla = `Fecha Lectura Anterior;Fecha Lectura;kWh1\n2022/01/01;2022/02/01;0\n2022/02/01;2022/03/01;0\n2022/03/01;2022/04/01;0\n2022/04/01;2022/05/01;0\n2022/05/01;2022/06/01;0\n2022/06/01;2022/07/01;0\n2022/07/01;2022/08/01;0\n2022/08/01;01/09/2022;0\n2022/09/01;2022/10/01;0\n2022/10/01;2022/11/01;0\n2022/11/01;2022/12/01;0\n2022/12/01;2022/12/31;0\n`;
  downloadFile(
    new File([plantilla], "plantilla_lecturas_estudio_express.csv", {}),
    false
  );
}

function isEmptyValue(value) {
  return value === null || value === undefined || value === "";
}

function isPositiveNumber(value) {
  return !isEmptyValue(value) && Number(value) > 0;
}

function isNonNegativeNumber(value) {
  return !isEmptyValue(value) && Number(value) >= 0;
}

function getAnosFinanciacionValue(opciones) {
  const key = Object.keys(opciones || {}).find((currentKey) =>
    currentKey.toLowerCase().includes("financiacion")
  );

  return key ? opciones[key] : opciones?.anos_financiacion;
}

function getValidationErrors() {
  const errores = [];
  const estudio = props.estudio || {};
  const opciones = opcionesAutoestudio.value || {};
  const cupsPrincipal =
    estudio.cups_principal?.cups || estudio.cups_principal || null;
  const inclinacion = isEmptyValue(estudio.inclinacion)
    ? opciones.inclinacion
    : estudio.inclinacion;
  const azimut = isEmptyValue(estudio.azimut)
    ? opciones.azimut
    : estudio.azimut;
  const anosFinanciacion =
    opciones["aÃ±os_financiacion"] ??
    opciones["aÃƒÂ±os_financiacion"] ??
    opciones.anos_financiacion;
  if (opciones.anos_financiacion == null && anosFinanciacion != null) {
    opciones.anos_financiacion = anosFinanciacion;
  }
  if (getAnosFinanciacionValue(opciones) != null) {
    opciones.anos_financiacion = getAnosFinanciacionValue(opciones);
  }

  if (!cupsPrincipal) errores.push("Falta el CUPS principal");
  if (isEmptyValue(inclinacion)) errores.push("Falta la inclinacion");
  if (isEmptyValue(azimut)) errores.push("Falta el azimut");
  if (isEmptyValue(estudio.latitud)) errores.push("Falta la latitud");
  if (isEmptyValue(estudio.longitud)) errores.push("Falta la longitud");

  if (
    opciones.plantilla === "COLABORADORES_EXT" &&
    isEmptyValue(opciones.idColaboradorExterno)
  ) {
    errores.push("Falta seleccionar el colaborador externo");
  }

  if (
    opciones.plantilla === "NUEVA_AISLADA" &&
    isEmptyValue(opciones.aisladas)
  ) {
    errores.push("Falta seleccionar el tipo de aislada");
  }

  if (
    opciones.plantilla === "NUEVA_ESTANDAR_BATERIAS" &&
    !isNonNegativeNumber(opciones.baterias)
  ) {
    errores.push("Falta indicar una cantidad valida de baterias");
  }

  if (opciones.precio_ibi) {
    if (!isPositiveNumber(opciones.porcentaje_ibi)) {
      errores.push("Falta el porcentaje de IBI");
    }
    if (!isPositiveNumber(opciones.anos_ibi)) {
      errores.push("Faltan los anos de IBI");
    }
    if (!isPositiveNumber(opciones.coste_ibi)) {
      errores.push("Falta el coste del IBI");
    }
  }

  if (
    !isEmptyValue(opciones.potencia_solicitada) &&
    opciones.potencia_solicitada !== "Coste 0" &&
    !isPositiveNumber(opciones.potencia_solicitada)
  ) {
    errores.push("La potencia solicitada debe ser mayor que 0");
  }

  if (
    !isEmptyValue(opciones.superficie_disponible) &&
    opciones.superficie_disponible !== "cubiertas" &&
    !isPositiveNumber(opciones.superficie_disponible)
  ) {
    errores.push("La superficie disponible debe ser mayor que 0");
  }

  if (
    !isEmptyValue(opciones.precio_medio) &&
    !isPositiveNumber(opciones.precio_medio)
  ) {
    errores.push("El precio medio debe ser mayor que 0");
  }

  if (!isEmptyValue(opciones.precio_wp) && !isPositiveNumber(opciones.precio_wp)) {
    errores.push("El precio por Wp debe ser mayor que 0");
  }

  if (
    opciones.calcular_financiacion &&
    !isPositiveNumber(opciones["aÃ±os_financiacion"] || opciones.anos_financiacion)
  ) {
    errores.push("Faltan los anos de financiacion");
  }

  if (!isEmptyValue(opciones.interes) && Number(opciones.interes) < 0) {
    errores.push("El interes no puede ser negativo");
  }

  if (
    !isEmptyValue(opciones.simulacion_vecinos) &&
    (!Number.isInteger(Number(opciones.simulacion_vecinos)) ||
      Number(opciones.simulacion_vecinos) <= 0)
  ) {
    errores.push("La simulacion de vecinos debe ser un entero mayor que 0");
  }

  if (
    !isEmptyValue(opciones.excedentes_buscados) &&
    (Number(opciones.excedentes_buscados) < 0 ||
      Number(opciones.excedentes_buscados) > 100)
  ) {
    errores.push("Los excedentes buscados deben estar entre 0 y 100");
  }

  if (opciones.precio_oferta_alumbra) {
    if (!isPositiveNumber(opciones.precio_oferta_compra_alumbra)) {
      errores.push("Falta el precio de compra de la oferta Alumbra");
    }
    if (!isPositiveNumber(opciones.precio_oferta_venta_alumbra)) {
      errores.push("Falta el precio de venta de la oferta Alumbra");
    }
  }

  return errores;
}

async function estudioExpress() {
  emit("update:creatingAutoestudio", true);
  error.value = null;
  const pdfWindow = window.open("", "_blank");

  if (pdfWindow) {
    pdfWindow.document.write(`
      <!doctype html>
      <html>
        <head>
          <title>Generando PDF...</title>
          <style>
            body {
              margin: 0;
              font-family: Arial, sans-serif;
              display: flex;
              align-items: center;
              justify-content: center;
              min-height: 100vh;
              color: #1f2937;
              background: #f9fafb;
            }
          </style>
        </head>
        <body>Generando PDF...</body>
      </html>
    `);
    pdfWindow.document.close();
  }

  const errores = getValidationErrors();
  if (errores.length > 0) {
    const mensaje = errores.join("\n");
    error.value = mensaje;
    pdfWindow?.close();
    window.alert(mensaje);
    emit("update:creatingAutoestudio", false);
    return;
  }

  const formData = new FormData();
  formData.append(
    "data",
    JSON.stringify({
      tipo: "estudio_express",
      ...opcionesAutoestudio.value,
    })
  );
  if (lecturas_manuales.value)
    formData.append("lecturas_manuales", lecturas_manuales.value);

  await crearEstudio({ data: formData, block: true });

  if (error.value) {
    pdfWindow?.close();
    window.alert(error.value);
  } else {
    const file = new File([data.value], `estudio_express_${props.idEstudio}.pdf`, {
      type: "application/pdf",
    });
    const pdfUrl = URL.createObjectURL(file);

    if (pdfWindow) {
      pdfWindow.document.open();
      pdfWindow.document.write(`
        <!doctype html>
        <html>
          <head>
            <title>${file.name}</title>
            <style>
              html, body {
                margin: 0;
                height: 100%;
                background: #525659;
              }
              iframe {
                border: 0;
                width: 100%;
                height: 100%;
              }
            </style>
          </head>
          <body>
            <iframe src="${pdfUrl}" title="${file.name}"></iframe>
          </body>
        </html>
      `);
      pdfWindow.document.close();
    } else {
      downloadFile(file, true);
    }

    window.setTimeout(() => URL.revokeObjectURL(pdfUrl), 60000);
    emit("reload");
  }
}

const superficieDisponible = computed(() => {
  return (props.estudio?.cubiertas || []).reduce((p, a) => p + a.area, 0);
});

defineExpose({ estudioExpress })

</script>

<style></style>
